import styled from "styled-components";

export const TabContainer = styled.div`
  padding: 2rem 2rem 0 0;
  color: #12100C !important;
`;